
module.exports = { 
      attributes: {},
    
      html: "<p><img src=\"images/jk.png\" alt=\"avatar\"></p>\n",
     }